export default __webpack_public_path__ + "static/sp-dropdown-977b28bb95db3ceff0b96561ed9cf2ee.png";